export const handleError = (e, dispatch) =>{
      let response = e?.response;
      let message = e?.response?.data?.message
      dispatch({
        type: "SHOW_ALERT",
        alertType: "error",
        message: message,
      });

  }